class Newsletter extends HTMLElement {
  constructor() {
    super();

    this.privacyPolicyWrapper = this.querySelector('.privacy_policy_wrapper');
    this.checkbox = this.privacyPolicyWrapper.querySelector('input[name="agree"]');
    this.checkbox.classList.add('hidden');

    this.btnCheckbox = this.privacyPolicyWrapper.querySelector('button.checkbox[type="button"]');
    this.activeCheckboxImage = this.btnCheckbox.querySelector('svg.active');
    this.inactiveCheckboxImage = this.btnCheckbox.querySelector('svg:not(.active)');

    this.checkbox = this.privacyPolicyWrapper.querySelector('input[name="agree"]');
    this.btnSubmit = this.privacyPolicyWrapper.querySelector('button.submit[type="button"]');

    this.btnCheckbox.addEventListener(
      'click',
      this.onButtonCheckboxClick.bind(this)
    );

    this.btnSubmit.addEventListener(
      'click',
      this.onButtonSubmitClick.bind(this)
    );
  }

  onButtonCheckboxClick(event) {
    event.preventDefault();
    this.checkbox.checked
      ? this.disable()
      : this.enable(event);
  }

  onButtonSubmitClick(event) {
    event.preventDefault();
    this.checkbox.checked
      && this.submitForm();
  }

  enable(event) {
    this.checkbox.checked = true;
    this.activeCheckboxImage.classList.remove('hidden');
    this.inactiveCheckboxImage.classList.add('hidden');
    this.btnSubmit.classList.remove('disabled');
  }

  disable(focusToggle = true) {
    this.checkbox.checked = false;
    this.activeCheckboxImage.classList.add('hidden');
    this.inactiveCheckboxImage.classList.remove('hidden');
    this.btnSubmit.classList.add('disabled');
  }

  submitForm(event) {
    this.querySelector('form').submit();
  }
}

customElements.get('newsletter-homepage') || customElements.define('newsletter-homepage', Newsletter);